<template>
  <div :id="appId">
    <router-view/>
  </div>
</template>

<script>
import platformConfig from './config/PlatformConfig'

export default {
  name: 'App',
  mounted () {
    document.title = this.$t(this.title)
  },
  data () {
    return {
      appId: platformConfig.appId,
      title: platformConfig.title
    }
  },
  methods: {
  },
  components: {
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/dev/index.scss';
// 字體
@import './assets/font/font.css';
/* 拼音文字不斷字 開始 */
.v-transfer-dom,
.ivu-notice{
  word-wrap: break-word;
}
.ivu-table-cell {
  word-break: break-word;
}
/* 拼音文字不斷字 結束*/
/* 共用區開始 */
.width-100 {
  width: 100%;
}
/* 共用區結束 */
</style>
